import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    footer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 24,
        padding: '20px 32px',
        borderTop: '1px solid rgba(255,255,255,0.04)',
        background: 'rgba(6,6,10,0.6)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        marginLeft: 72, /* sidebar collapsed width */
    },
    item: {
        fontFamily: "'Exo 2', 'Exo 2', sans-serif",
        fontSize: 11,
        fontWeight: 500,
        color: 'rgba(255,255,255,0.2)',
        textDecoration: 'none',
        letterSpacing: '0.2px',
        transition: 'color 0.2s ease',
        '&:hover': {
            color: 'rgba(255,255,255,0.5)',
        },
    },
    dot: {
        color: 'rgba(255,255,255,0.08)',
        fontSize: 10,
        userSelect: 'none',
    },
}));

export default function BottomBar() {
    const classes = useStyles();

    return (
        <footer className={classes.footer}>
            <span className={classes.item}>
                © {new Date().getFullYear()} Athletes Launch
            </span>
            <span className={classes.dot}>·</span>
            <Link to="/legal?tab=terms" className={classes.item}>Terms</Link>
            <span className={classes.dot}>·</span>
            <Link to="/legal?tab=privacy" className={classes.item}>Privacy</Link>
            <span className={classes.dot}>·</span>
            <a
                className={classes.item}
                href="mailto:info@athleteslaunch.com"
            >
                Contact
            </a>
        </footer>
    );
}